import { render, staticRenderFns } from "./clientManagement.vue?vue&type=template&id=6aea1b98&scoped=true"
import script from "./clientManagement.vue?vue&type=script&lang=js"
export * from "./clientManagement.vue?vue&type=script&lang=js"
import style0 from "./clientManagement.vue?vue&type=style&index=0&id=6aea1b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea1b98",
  null
  
)

export default component.exports